export default __webpack_public_path__ + "static/media/tni-au-bg.b7a6d818.jpeg";